module.exports = __webpack_public_path__ + "img/pare-vapeur.8fa096a7.png";